import { api } from "./client";
import type { Tenant, User } from "../stores/auth";

export type SignupPayload = {
  office_name: string;
  owner_name: string;
  owner_email: string;
  phone: string;
  password: string;
  pc_count: number;
};

export type TokenPair = {
  access_token: string;
  refresh_token: string;
  mfa_required: boolean;
};

export type SignupResponse = TokenPair & {
  user: User;
  tenant: Tenant;
};

export type LoginResponseMfaRequired = {
  mfa_required: true;
  challenge_token: string;
  challenge_ttl_seconds: number;
};

export type LoginResponse = TokenPair | LoginResponseMfaRequired;

export type EnrollResponse = {
  provisioning_uri: string;
  secret_base32: string;
  qr_png_base64: string;
};

export type MeResponse = {
  user: User;
  tenant: Tenant;
  role: string;
};

export async function signup(payload: SignupPayload) {
  const { data } = await api.post<SignupResponse>("/auth/signup", payload);
  return data;
}

export async function login(email: string, password: string) {
  const { data } = await api.post<LoginResponse>("/auth/login", { email, password });
  return data;
}

export async function mfaEnroll() {
  const { data } = await api.post<EnrollResponse>("/auth/mfa/enroll");
  return data;
}

export async function mfaVerify(code: string) {
  const { data } = await api.post<TokenPair>("/auth/mfa/verify", { code });
  return data;
}

export async function mfaChallenge(challenge_token: string, code: string) {
  const { data } = await api.post<TokenPair>("/auth/mfa/challenge", {
    challenge_token,
    code,
  });
  return data;
}

export async function me() {
  const { data } = await api.get<MeResponse>("/auth/me");
  return data;
}

export async function logout(refresh_token: string) {
  await api.post("/auth/logout", { refresh_token });
}

export async function requestPasswordReset(email: string): Promise<void> {
  await api.post("/auth/password-reset/request", { email });
}

export async function confirmPasswordReset(
  uid: string,
  token: string,
  new_password: string,
): Promise<void> {
  await api.post("/auth/password-reset/confirm", { uid, token, new_password });
}
